export function decapitalize(value: string): string {
	if (value === "")
		return ""
	return value.charAt(0).toLowerCase() + value.slice(1)
}

export function capitalize(value: string): string {
	if (value === "")
		return ""

	return value.charAt(0).toUpperCase() + value.slice(1)
}

export function decamelCase(value: string): string {
	if (value === "")
		return ""

	return value.replace(/([A-Z])/g, " $1")
}

export const emptyString = ""
